import { Routes } from '@angular/router';

import { authGuard } from './auth.guard';
import { authResolver } from './auth.resolver';

export const USER_ROUTES: Routes = [
  {
    path: 'user',
    loadComponent: () => import('./views/user/user.component').then(m => m.UserComponent),
    canActivate: [authGuard],
    resolve: { auth: authResolver },
    children: [
      {
        path: 'data',
        loadComponent: () => import('./views/user/data/data.component').then(m => m.DataComponent)
      },
      {
        path: 'booking',
        loadComponent: () => import('./views/user/booking/booking.component').then(m => m.BookingComponent)
      },
      {
        path: 'preset',
        loadComponent: () => import('./views/user/preset/preset.component').then(m => m.PresetComponent)
      },
      {
        path: 'account',
        loadComponent: () => import('./views/user/account/account.component').then(m => m.AccountComponent)
      },
      {
        path: '',
        redirectTo: 'data',
        pathMatch: 'full'
      }
    ]
  }
];

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'session',
    pathMatch: 'full'
  },
  {
    path: 'ticket/book',
    redirectTo: 'session',
    pathMatch: 'full'
  },
  {
    path: 'session',
    loadComponent: () => import('./views/session-list/session-list.component').then(m => m.SessionListComponent)
  },
  {
    path: 'booking/:locationId',
    loadComponent: () => import('./views/booking-detail/booking-detail.component').then(m => m.BookingDetailComponent)
  },
  {
    path: 'order/:locationId',
    loadComponent: () => import('./views/order-detail/order-detail.component').then(m => m.OrderDetailComponent)
  },
  {
    path: 'login',
    loadComponent: () => import('./views/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'register',
    loadComponent: () => import('./views/register/register.component').then(m => m.RegisterComponent)
  },
  {
    path: 'logout',
    loadComponent: () => import('./views/logout/logout.component').then(m => m.LogoutComponent)
  },
  {
    path: 'reset-password',
    loadComponent: () => import('./views/reset-password/reset-password.component').then(m => m.ResetPasswordComponent)
  },
  {
    path: 'verify-email',
    loadComponent: () => import('./views/verify-email/verify-email.component').then(m => m.VerifyEmailComponent)
  },
  ...USER_ROUTES
];
